import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconEyeSlash16(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48 4.187a.5.5 0 01.707-.707l8.333 8.333a.5.5 0 11-.707.707L3.48 4.187zm-1.193 3.53a8.962 8.962 0 011.94-2.075l.715.714A7.652 7.652 0 003.313 8c1.36 1.832 3.05 2.696 4.687 2.696.38 0 .761-.046 1.141-.14l.803.802A5.811 5.811 0 018 11.696c-2.118 0-4.178-1.178-5.713-3.413a.5.5 0 010-.566zm3.769-3.075l.803.802c.38-.094.762-.14 1.141-.14 1.637 0 3.327.864 4.687 2.696a7.65 7.65 0 01-1.63 1.644l.715.714c.705-.536 1.36-1.23 1.941-2.075a.5.5 0 000-.566C12.178 5.482 10.118 4.304 8 4.304a5.81 5.81 0 00-1.944.338zM6 8c0-.18.024-.353.068-.518l2.45 2.45A2.003 2.003 0 016 8zm1.482-1.932l2.45 2.45a2.003 2.003 0 00-2.45-2.45z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconEyeSlash16);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;